import { cn } from '@/lib/utils';
import type { SessionFlags } from '@pulse/shared';

interface Props {
  flags: SessionFlags;
}

export function FlagDots({ flags }: Props) {
  const items: Array<{ key: keyof SessionFlags; cls: string; label: string }> = [
    { key: 'rage_click', cls: 'bg-danger', label: 'Rage click' },
    { key: 'dead_click', cls: 'bg-warning', label: 'Dead click' },
    { key: 'quick_back', cls: 'bg-text-subtle', label: 'Quick back' },
    { key: 'error', cls: 'bg-danger', label: 'JS error' },
  ];

  return (
    <div className="inline-flex gap-1">
      {items.map((i) =>
        flags[i.key] ? (
          <span key={i.key} className={cn('size-1.5 rounded-full', i.cls)} title={i.label} />
        ) : null,
      )}
    </div>
  );
}
